import React from "react";
import "../Resources.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiBookOpen,
    FiShield,
    FiCreditCard,
    FiCpu,
    FiFileText,
    FiTrendingUp,
    FiCheckCircle,
    FiArrowRight
} from "react-icons/fi";


const Resources = () => {

    return (
        <>

            <Header />


            <div className="resources-page">


                {/*=====================================================
                    HERO
======================================================*/}


                <section className="resources-hero">


                    <div className="container">


                        <div className="resources-hero-content">


                            <span className="resources-tag">
                                FINTECH RESOURCES
                            </span>


                            <h1>

                                Knowledge Hub For

                                <span>
                                    Modern Financial Technology
                                </span>

                            </h1>


                            <p>

                                Explore expert insights, compliance guides,
                                technology updates, and fintech resources
                                designed to help financial institutions
                                build secure, scalable, and future-ready
                                digital ecosystems.

                            </p>


                            <div className="resources-buttons">


                                <a href="/contact"
                                    
                                    className="resource-primary-btn"
                                >
                                    Talk To Experts
                                </a>


                                {/* <Link
                                    to="/services"
                                    className="resource-secondary-btn"
                                >
                                    Explore Solutions
                                </Link> */}


                            </div>


                        </div>


                    </div>


                </section>




                {/*=====================================================
                    BREADCRUMB
======================================================*/}


                <section className="resources-breadcrumb">

                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />


                        <span>
                            Resources
                        </span>


                    </div>

                </section>





                {/*=====================================================
                    KNOWLEDGE HUB
======================================================*/}


                <section className="knowledge-section">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                KNOWLEDGE HUB
                            </span>


                            <h2>

                                Resources To Drive

                                <span>
                                    Financial Innovation
                                </span>

                            </h2>


                            <p>

                                Stay informed with industry knowledge,
                                technology trends, and compliance
                                best practices from the fintech ecosystem.

                            </p>


                        </div>




                        <div className="resource-grid">



                            <div className="resource-card">

                                <div className="resource-icon">

                                    <FiBookOpen />

                                </div>


                                <h3>
                                    FinTech Insights
                                </h3>


                                <p>

                                    Understand emerging fintech trends,
                                    digital banking innovations, payment
                                    technologies, and financial transformation.

                                </p>


                            </div>




                            <div className="resource-card">

                                <div className="resource-icon">

                                    <FiShield />

                                </div>


                                <h3>
                                    Compliance Resources
                                </h3>


                                <p>

                                    Learn about AML, KYC, regulatory
                                    requirements, risk management,
                                    and compliance frameworks.

                                </p>


                            </div>





                            <div className="resource-card">

                                <div className="resource-icon">

                                    <FiCreditCard />

                                </div>


                                <h3>
                                    Payment Technology
                                </h3>


                                <p>

                                    Explore secure payment solutions,
                                    transaction monitoring, APIs,
                                    and digital payment infrastructure.

                                </p>


                            </div>





                            <div className="resource-card">

                                <div className="resource-icon">

                                    <FiCpu />

                                </div>


                                <h3>
                                    Technology Updates
                                </h3>


                                <p>

                                    Discover automation, cloud solutions,
                                    AI adoption, and modern fintech
                                    architecture.

                                </p>


                            </div>



                        </div>


                    </div>


                </section>







                {/*=====================================================
                FEATURE RESOURCES
======================================================*/}


                <section className="featured-resources">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                FEATURED CONTENT
                            </span>


                            <h2>

                                Latest

                                <span>
                                    FinTech Knowledge
                                </span>

                            </h2>


                        </div>




                        <div className="article-grid">



                            <div className="article-card">


                                <FiFileText />


                                <h3>
                                    Understanding AML Compliance
                                </h3>


                                <p>

                                    A complete overview of AML practices,
                                    transaction monitoring, and regulatory
                                    compliance requirements.

                                </p>


                                {/* <Link to="#">

                                    Read More
                                    <FiArrowRight />

                                </Link> */}


                            </div>





                            <div className="article-card">


                                <FiShield />


                                <h3>
                                    Importance of KYC Verification
                                </h3>


                                <p>

                                    How digital identity verification helps
                                    businesses prevent fraud and improve
                                    customer onboarding.

                                </p>


                                {/* <Link to="#">

                                    Read More
                                    <FiArrowRight />

                                </Link> */}


                            </div>





                            <div className="article-card">


                                <FiTrendingUp />


                                <h3>
                                    Future Of Digital Finance
                                </h3>


                                <p>

                                    Explore how automation, AI, APIs,
                                    and cloud technology are transforming
                                    financial services.

                                </p>


                                {/* <Link to="#">

                                    Read More
                                    <FiArrowRight />

                                </Link> */}


                            </div>



                        </div>


                    </div>


                </section>








                {/*=====================================================
                WHY RESOURCES
======================================================*/}


                <section className="resource-benefits">


                    <div className="container">


                        <div className="benefits-box">


                            <div>


                                <h2>

                                    Why Choose Our

                                    <span>
                                        FinTech Expertise
                                    </span>

                                </h2>


                                <p>

                                    Our resources are created from
                                    real-world fintech experience,
                                    helping organizations improve
                                    security, compliance, and digital
                                    operations.

                                </p>


                            </div>




                            <div className="benefit-list">


                                <div style={{color:"#fff"}}>

                                    <FiCheckCircle />

                                    Industry-focused knowledge

                                </div>


                                <div style={{color:"#fff"}}>

                                    <FiCheckCircle />

                                    Compliance-driven approach

                                </div>


                                <div style={{color:"#fff"}}>

                                    <FiCheckCircle />

                                    Technology innovation insights

                                </div>


                                <div style={{color:"#fff"}}>

                                    <FiCheckCircle />

                                    Secure digital transformation guidance

                                </div>


                            </div>



                        </div>


                    </div>


                </section>






                {/*=====================================================
                    CTA
======================================================*/}


                <section className="resources-cta">


                    <div className="container">


                        <div className="resources-cta-box">


                            <h2>

                                Need Expert

                                <span>
                                    FinTech Guidance?
                                </span>

                            </h2>


                            <p>

                                Connect with Saivari Fintech experts
                                to discuss compliance, technology,
                                automation, and digital transformation
                                solutions.

                            </p>


                            <a
                                href="/contact"
                                className="resource-primary-btn"
                            >

                                Contact Experts

                            </a>



                        </div>


                    </div>


                </section>



            </div>


            <Footer />


        </>

    )

}


export default Resources;